module.exports = __webpack_public_path__ + "0101054a66a19122f5b905c4d97fdcb4.pdf";